import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { BrandingProvider } from "@/lib/branding";
import { ThemeProvider } from "@/lib/theme";
import Landing from "@/pages/Landing";
import SuperAdmin from "@/pages/SuperAdmin";
import HospitalAdmin from "@/pages/HospitalAdmin";
import DoctorPortal from "@/pages/DoctorPortal";
import PatientDetailForDoctor from "@/pages/PatientDetailForDoctor";
import PatientPortal from "@/pages/PatientPortal";
import NurseDashboard from "@/pages/NurseDashboard";

const Branded = ({ children }) => <BrandingProvider>{children}</BrandingProvider>;

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <BrowserRouter>
          <Toaster position="top-right" richColors closeButton />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/super-admin" element={<SuperAdmin />} />
            <Route path="/:hospCode/admin" element={<Branded><HospitalAdmin /></Branded>} />
            <Route path="/:hospCode/doctor" element={<Branded><DoctorPortal /></Branded>} />
            <Route path="/:hospCode/nurse" element={<Branded><NurseDashboard /></Branded>} />
            <Route path="/:hospCode/doctor/patient/:patientId" element={<Branded><PatientDetailForDoctor /></Branded>} />
            <Route path="/:hospCode/patient/:patientId" element={<Branded><PatientPortal /></Branded>} />
          </Routes>
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
